<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>Contratar acordo</h1>
    </div>

    <app-informacoes-cartao class="informacoes-cartao" [debtValue]="debt?.valorDivida" [nomeProduto]="debt?.nomeProduto" [customerName]="customerData?.nome" [numeroCartaoMascarado]="numeroCartaoMascarado"></app-informacoes-cartao>

    <app-informacoes-proposta class="informacoes-proposta" [debt]="debt" [ofertaAtual]="ofertaAtual"></app-informacoes-proposta>

     <div class="informacoes-termos">
      <h2>TERMOS E CONDIÇÕES</h2>
      <div class="info-container">
         <p [innerHTML]="textoTermos">
        </p>
          <mat-checkbox color="primary" [(ngModel)]="aceitoBtn" (change)="confirmarLeituraTermosLog()">Li e concordo com os termos e condições </mat-checkbox>
      </div>
    </div>

    <div class="actions-container">
      <div class="actions">
        <button (click)="downloadTermo()" [disabled]="!aceitoBtn" type="button" mat-button class="outlined" mat-stroked-button color="primary">
          Download
        </button>
        <div class="btns">
           <button type="button" (click)="cancelarContratacao()" mat-button class="outlined" mat-stroked-button color="primary">
          Cancelar
        </button>
         <button (click)="aceitarTermos()" [disabled]="!aceitoBtn" type="button" mat-button mat-flat-button color="primary">
          Confirmar Acordo
        </button>
        </div>
       
      </div>
    </div> 
  </div>
</section>